import React from "react";
import Link from "next/link";
import { APP_STORE_LINK, PLAY_STORE_LINK } from "@olivahealth/constants";
import useTranslation from "../../../../../apps/web-client/src/hooks/useTranslation";
import Onelink1To1 from "../../../../../apps/web-client/src/components/common/QRCodes/Onelink1To1";
import { Text } from "../../../index";
import Image from "../../../../../apps/web-client/src/components/common/Image";

import * as s from "./styles";

export const MobileAppDownloader: React.FC<{ showDownloadLinks?: boolean }> = ({
  showDownloadLinks = true,
}) => {
  const { t } = useTranslation("companionV2");

  return (
    <div className={s.mobileAppBannerContainer}>
      <div className="flex items-center gap-2">
        <div className={s.phoneIconWrapper}>
          <Image
            className="object-contain self-center"
            src="/img/img_phone_download.png"
            alt={t("appDownloadBanner.appStoreAlt")}
            width={42}
            height={75}
          />
        </div>
        <Text weight="bold" size="xl">
          {t("appDownloadBanner.title")}
        </Text>
      </div>

      <div className={s.rightContent}>
        <div className={s.qrCodeWrapper}>
          <Onelink1To1 height={88} width={88} />
        </div>
        {showDownloadLinks && (
          <div className={s.mobileAppLinksWrapper}>
            <Link href={APP_STORE_LINK} target="_blank">
              <Image
                className="object-contain min-w-32"
                src="/img/download_app_store_white.png"
                alt={t("appDownloadBanner.appStoreAlt")}
                width={138}
                height={40}
              />
            </Link>
            <Link href={PLAY_STORE_LINK} target="_blank">
              <Image
                className="object-contain min-w-32"
                src="/img/download_google_play_white.png"
                alt={t("appDownloadBanner.playStoreAlt")}
                width={138}
                height={40}
              />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};
